import * as types from './types'
const mutations = {
  [types.LOGIN]: (state, data) => {
    localStorage.token = data;
    state.token = data;
  },
  [types.LOGOUT]: (state) => {
    localStorage.removeItem('token');
    sessionStorage.unreadMsg = 0
    state.unread_msg = 0
    state.token = null
  },
  [types.TITLE]: (state, data) => {
    state.title = data;
  },
  [types.LANGUAGE]:(state,data) =>{
    localStorage.language = data
    state.language = data
  },
  [types.USER]:(state,data) =>{
    localStorage.user = data
    state.user = data
  },
  [types.LEVEL]:(state,data) =>{
    localStorage.level = data
    state.level = data
  },
  [types.CHANNEL]:(state,data) =>{
    localStorage.channel = data
    state.channel = data
  },
  [types.ADDCRUMBS] (state, payload) {
    state.crumbs_arr = payload
  },
  [types.CURRENTNAME] (state, payload) {
    state.current_name = payload
  },
  [types.AREAID] (state, payload) {
    state.area_id = payload
  },
  [types.ORDERTYPE] (state, payload) {
    state.order_type = payload
  },
  [types.ORGID] (state, payload) {
    state.org_id = payload
  },
  [types.BASICINFO] (state, payload) {
    state.basic_info = payload
  },
  [types.ALIPAYHTML] (state, payload) {
    state.alipay_html = payload
  },
  [types.LEADERINFO] (state, payload) {
    state.leader_info = payload
  },
  [types.ISONLINE] (state, payload) {
    state.is_online = payload
  },
  [types.COUNTRYCODE] (state, payload) {
    state.country_code = payload
  },
  [types.COUNTRYNAME] (state, payload) {
    state.country_name = payload
  },
  [types.SETUNREADMSG] (state, payload) {
    sessionStorage.unreadMsg = payload
    state.unread_msg = payload
  }
}
export default  mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js